/** Pick first defined property from obj using camelCase or PascalCase keys. */
const pick = (obj, camel, pascal) => {
  if (!obj || typeof obj !== "object") return undefined;
  if (obj[camel] != null) return obj[camel];
  if (pascal && obj[pascal] != null) return obj[pascal];
  return undefined;
};

const mapDict = (obj, camel, pascal) => pick(obj, camel, pascal) || {};

const normalizeS1_6 = (raw) => {
  if (!raw || typeof raw !== "object") return null;
  return {
    countryEmployeeCountForTotal: mapDict(raw, "countryEmployeeCountForTotal", "CountryEmployeeCountForTotal"),
    regionEmployeeCountForTotal: mapDict(raw, "regionEmployeeCountForTotal", "RegionEmployeeCountForTotal"),
    countryEmployeeCountForPermanent: mapDict(raw, "countryEmployeeCountForPermanent", "CountryEmployeeCountForPermanent"),
    regionEmployeeCountForPermanent: mapDict(raw, "regionEmployeeCountForPermanent", "RegionEmployeeCountForPermanent"),
    countryEmployeeCountForTemporary: mapDict(raw, "countryEmployeeCountForTemporary", "CountryEmployeeCountForTemporary"),
    regionEmployeeCountForTemporary: mapDict(raw, "regionEmployeeCountForTemporary", "RegionEmployeeCountForTemporary"),
    countryEmployeeCountForNonGuaranteed: mapDict(raw, "countryEmployeeCountForNonGuaranteed", "CountryEmployeeCountForNonGuaranteed"),
    regionEmployeeCountForNonGuaranteed: mapDict(raw, "regionEmployeeCountForNonGuaranteed", "RegionEmployeeCountForNonGuaranteed"),
    countryEmployeeCountForFullTime: mapDict(raw, "countryEmployeeCountForFullTime", "CountryEmployeeCountForFullTime"),
    regionEmployeeCountForFullTime: mapDict(raw, "regionEmployeeCountForFullTime", "RegionEmployeeCountForFullTime"),
    countryEmployeeCountForPartTime: mapDict(raw, "countryEmployeeCountForPartTime", "CountryEmployeeCountForPartTime"),
    regionEmployeeCountForPartTime: mapDict(raw, "regionEmployeeCountForPartTime", "RegionEmployeeCountForPartTime"),
  };
};

const num = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

const normalizeS1_7 = (raw) => {
  if (!raw || typeof raw !== "object") return null;
  return {
    contractMaleCount: num(pick(raw, "contractMaleCount", "ContractMaleCount")),
    contractFemaleCount: num(pick(raw, "contractFemaleCount", "ContractFemaleCount")),
    contractOtherCount: num(pick(raw, "contractOtherCount", "ContractOtherCount")),
    contractNotDisclosedCount: num(pick(raw, "contractNotDisclosedCount", "ContractNotDisclosedCount")),
    nonEmployeesMaleCount: num(pick(raw, "nonEmployeesMaleCount", "NonEmployeesMaleCount")),
    nonEmployeesFemaleCount: num(pick(raw, "nonEmployeesFemaleCount", "NonEmployeesFemaleCount")),
    nonEmployeesOtherCount: num(pick(raw, "nonEmployeesOtherCount", "NonEmployeesOtherCount")),
    nonEmployeesNotDisclosedCount: num(pick(raw, "nonEmployeesNotDisclosedCount", "NonEmployeesNotDisclosedCount")),
  };
};

const normalizeS1_13 = (raw) => {
  if (!raw || typeof raw !== "object") return null;
  return {
    permanentEmployeesMaleCount: num(pick(raw, "permanentEmployeesMaleCount", "PermanentEmployeesMaleCount")),
    permanentEmployeesFemaleCount: num(pick(raw, "permanentEmployeesFemaleCount", "PermanentEmployeesFemaleCount")),
    temporaryEmployeesMaleCount: num(pick(raw, "temporaryEmployeesMaleCount", "TemporaryEmployeesMaleCount")),
    temporaryEmployeesFemaleCount: num(pick(raw, "temporaryEmployeesFemaleCount", "TemporaryEmployeesFemaleCount")),
    nonGuarEmployeesMaleCount: num(pick(raw, "nonGuarEmployeesMaleCount", "NonGuarEmployeesMaleCount")),
    nonGuarEmployeesFemaleCount: num(pick(raw, "nonGuarEmployeesFemaleCount", "NonGuarEmployeesFemaleCount")),
    fullTimeEmployeesMaleCount: num(pick(raw, "fullTimeEmployeesMaleCount", "FullTimeEmployeesMaleCount")),
    fullTimeEmployeesFemaleCount: num(pick(raw, "fullTimeEmployeesFemaleCount", "FullTimeEmployeesFemaleCount")),
    partTimeEmployeesMaleCount: num(pick(raw, "partTimeEmployeesMaleCount", "PartTimeEmployeesMaleCount")),
    partTimeEmployeesFemaleCount: num(pick(raw, "partTimeEmployeesFemaleCount", "PartTimeEmployeesFemaleCount")),
    nonEmployeesMaleCount: num(pick(raw, "nonEmployeesMaleCount", "NonEmployeesMaleCount")),
    nonEmployeesFemaleCount: num(pick(raw, "nonEmployeesFemaleCount", "NonEmployeesFemaleCount")),
  };
};

const normalizeS1_12 = (raw) => {
  if (!raw || typeof raw !== "object") return null;
  return {
    percentageMaleEmployeesWithDisability: pick(raw, "percentageMaleEmployeesWithDisability", "PercentageMaleEmployeesWithDisability"),
    percentageFemaleEmployeesWithDisability: pick(raw, "percentageFemaleEmployeesWithDisability", "PercentageFemaleEmployeesWithDisability"),
  };
};

const normalizeS1_15 = (raw) => {
  if (!raw || typeof raw !== "object") return null;
  return {
    percentageOfMaleEmployeesEntitledToTakeFamilyRelatedLeaves: pick(
      raw,
      "percentageOfMaleEmployeesEntitledToTakeFamilyRelatedLeaves",
      "PercentageOfMaleEmployeesEntitledToTakeFamilyRelatedLeaves"
    ),
    percentageOfFemaleEmployeesEntitledToTakeFamilyRelatedLeaves: pick(
      raw,
      "percentageOfFemaleEmployeesEntitledToTakeFamilyRelatedLeaves",
      "PercentageOfFemaleEmployeesEntitledToTakeFamilyRelatedLeaves"
    ),
    percentageOfMaleEmployeesThatTookFamilyRelatedLeaves: pick(
      raw,
      "percentageOfMaleEmployeesThatTookFamilyRelatedLeaves",
      "PercentageOfMaleEmployeesThatTookFamilyRelatedLeaves"
    ),
    percentageOfFemaleEmployeesThatTookFamilyRelatedLeaves: pick(
      raw,
      "percentageOfFemaleEmployeesThatTookFamilyRelatedLeaves",
      "PercentageOfFemaleEmployeesThatTookFamilyRelatedLeaves"
    ),
    percentageOfMaleEmployeesThatTookMaternityPaternityAndOrParentalLeave: pick(
      raw,
      "percentageOfMaleEmployeesThatTookMaternityPaternityAndOrParentalLeave",
      "PercentageOfMaleEmployeesThatTookMaternityPaternityAndOrParentalLeave"
    ),
    percentageOfFemaleEmployeesThatTookMaternityPaternityAndOrParentalLeave: pick(
      raw,
      "percentageOfFemaleEmployeesThatTookMaternityPaternityAndOrParentalLeave",
      "PercentageOfFemaleEmployeesThatTookMaternityPaternityAndOrParentalLeave"
    ),
  };
};

const normalizeS1_8 = (raw) => {
  if (!raw || typeof raw !== "object") return null;
  return {
    percentageCoveredCollectiveBargainingEEA: pick(raw, "percentageCoveredCollectiveBargainingEEA", "PercentageCoveredCollectiveBargainingEEA"),
    percentageCoveredCollectiveBargainingNonEEA: pick(raw, "percentageCoveredCollectiveBargainingNonEEA", "PercentageCoveredCollectiveBargainingNonEEA"),
    percentageCoveredSocialProtectionEEA: pick(raw, "percentageCoveredSocialProtectionEEA", "PercentageCoveredSocialProtectionEEA"),
    collectiveBargainingEEAEmployees: pick(raw, "collectiveBargainingEEAEmployees", "CollectiveBargainingEEAEmployees"),
    collectiveBargainingNonEEAEmployees: pick(raw, "collectiveBargainingNonEEAEmployees", "CollectiveBargainingNonEEAEmployees"),
    socialProtectionEEAEmployees: pick(raw, "socialProtectionEEAEmployees", "SocialProtectionEEAEmployees"),
  };
};

/** Normalize GetEmployeeWellBeingS1 response for frontend (camelCase summaries). */
export function normalizeS1TablesApiResponse(payload) {
  if (!payload || typeof payload !== "object") return payload;
  const out = { ...payload };

  const s1_6 = normalizeS1_6(pick(out, "S1_6_Summary", "s1_6_Summary"));
  const s1_7 = normalizeS1_7(pick(out, "S1_7_Summary", "s1_7_Summary"));
  const s1_8 = normalizeS1_8(pick(out, "S1_8_Summary", "s1_8_Summary"));
  const s1_12 = normalizeS1_12(pick(out, "S1_12_Summary", "s1_12_Summary"));
  const s1_13 = normalizeS1_13(pick(out, "S1_13_Summary", "s1_13_Summary"));
  const s1_15 = normalizeS1_15(pick(out, "S1_15_Summary", "s1_15_Summary"));

  if (s1_6) out.S1_6_Summary = s1_6;
  if (s1_7) out.S1_7_Summary = s1_7;
  if (s1_8) out.S1_8_Summary = s1_8;
  if (s1_12) out.S1_12_Summary = s1_12;
  if (s1_13) out.S1_13_Summary = s1_13;
  if (s1_15) out.S1_15_Summary = s1_15;

  return out;
}

export function coerceLegalEntities(legalEntity) {
  if (Array.isArray(legalEntity)) {
    return legalEntity.map((le) => (typeof le === "string" ? le : le?.name || le?.legalEntityName || "")).filter(Boolean);
  }
  if (typeof legalEntity === "string" && legalEntity.trim()) {
    return legalEntity
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
  }
  return [];
}

export function hasS1_6Data(s1_6) {
  if (!s1_6) return false;
  const maps = [
    s1_6.countryEmployeeCountForTotal,
    s1_6.regionEmployeeCountForTotal,
  ];
  return maps.some((m) => m && typeof m === "object" && Object.keys(m).length > 0);
}

const toCellStr = (v) => (v == null || v === "" ? "" : String(v));

/** Build tableAnswers keys + column headers for S1-6 from a normalized summary. Regions are intentionally excluded — the S1-6 table only shows countries. */
export function buildS1_6TableAnswers(s1_6) {
  const countries = Object.keys(s1_6.countryEmployeeCountForTotal || {});
  const rows = [
    { key: "totalEmp", country: s1_6.countryEmployeeCountForTotal },
    { key: "permanent", country: s1_6.countryEmployeeCountForPermanent },
    { key: "temporary", country: s1_6.countryEmployeeCountForTemporary },
    { key: "nonGuaranteedHours", country: s1_6.countryEmployeeCountForNonGuaranteed },
    { key: "fullTime", country: s1_6.countryEmployeeCountForFullTime },
    { key: "partTime", country: s1_6.countryEmployeeCountForPartTime },
  ];
  const newAnswers = {};
  rows.forEach(({ key, country }) => {
    let total = 0;
    let hasNumbers = false;
    countries.forEach((c) => {
      const raw = country?.[c];
      newAnswers[`s1_6-${key}-${c}`] = toCellStr(raw);
      const n = Number(raw);
      if (Number.isFinite(n)) {
        total += n;
        hasNumbers = true;
      }
    });
    newAnswers[`s1_6-${key}-Total`] = hasNumbers ? String(total) : "";
  });
  return { countries, regions: [], newAnswers };
}
